import { Usuario } from "../../../../interfaces/usuario";

export class EntidadResponsable {
    constructor(
        public IdEntidadResponsable?: number | string,
        public usuario: Usuario = new Usuario()
    ) { }
}
